import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux';
import './index.css'
import App from './App.tsx'
import { store } from './redux/store.ts';
import { ProjectProviders } from './components/shared/ProjectProviders.tsx';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ProjectProviders>
        <App />
      </ProjectProviders>
    </Provider>
  </StrictMode>,
)
